// import React, { useCallback, useEffect, useState, memo } from 'react'
// import { Grid, Paper, Typography, makeStyles } from '@material-ui/core';
// import audioIcon from "../../assets/audioIcon.svg"
// import audioIcon2 from "../../assets/audioIcon2.svg"
// import videoIcon from "../../assets/videoIcon.svg"
// import videoIcon2 from "../../assets/videoIcon2.svg"
// import textIcon from "../../assets/textIcon.svg"
// import textIcon2 from "../../assets/textIcon2.svg"

// // Custom styles
// const useStyles = makeStyles(() => ({
//     header: {
//         backgroundColor: '#75287c',
//         color: '#ffffff',
//         fontWeight: 'bold',
//     },
//     row: {
//         borderBottom: '1px solid #ccc',
//     },
//     cell: {
//         padding: '12px 16px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//     },
//     bordered: {
//         borderLeft: '1px solid #ccc',
//     },
//     firstCell: {
//         padding: '12px 16px',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//     }
// }));

// function JPMCTestimonialMainGrid({ allUserTestimonials, searchedTestimonial, handleMobileClick, handleTestimonialIconClick }) {
//     const classes = useStyles();
//     return (
//         <div className='testimonialGrid'>
//             <Paper elevation={2} style={{ marginTop: '20px' }}>
//                 {/* Header Row (Fixed) */}
//                 <div style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#75287c' }}>
//                     <Grid container className={`${classes.header} ${classes.row}`}>
//                         <Grid item xs={3} className={classes.firstCell}>
//                             <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Customer Name</Typography>
//                         </Grid>
//                         <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                             <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Business Name</Typography>
//                         </Grid>
//                         <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                             <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Phone Number</Typography>
//                         </Grid>
//                         <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                             <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Testimonials</Typography>
//                         </Grid>
//                     </Grid>
//                 </div>

//                 {/* Scrollable Data Rows */}
//                 <div style={{ maxHeight: '700px', overflowY: 'auto' }}>
//                     {allUserTestimonials.length === 0 ? (
//                         <Grid container className={classes.row}>
//                             <Grid item xs={12} className={classes.cell}>
//                                 <Typography>No data available</Typography>
//                             </Grid>
//                         </Grid>
//                     ) : (
//                         searchedTestimonial ? (
//                             searchedTestimonial.map((cust, index) => (
//                                 <Grid container key={index} className={classes.row}>
//                                     <Grid item xs={3} className={classes.firstCell}>
//                                         <Typography>{cust.FullName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <Typography>{cust.sBusinessName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <Typography
//                                             style={{ cursor: "pointer" }} onClick={() => handleMobileClick(cust.sMobile)}>
//                                             {cust.sMobile}
//                                         </Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
//                                             {/* video */}
//                                             {
//                                                 cust.Video ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon} alt="Video" width={20} height={20} />
//                                                 ) : <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon2} alt="Video" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
//                                             }

//                                             {/* Audio */}
//                                             {
//                                                 cust.Audio ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon} alt="Audio" width={20} height={20} />
//                                                 ) : (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon2} alt="Audio" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
//                                                 )
//                                             }

//                                             {/* Text */}
//                                             {
//                                                 cust.Text ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon} alt="Text" width={20} height={20} />
//                                                 ) : (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon2} alt="Text" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
//                                                 )
//                                             }

//                                         </div>
//                                     </Grid>
//                                 </Grid>
//                             ))
//                         ) :
//                             (allUserTestimonials.map((cust, index) => (
//                                 <Grid container key={index} className={classes.row}>
//                                     <Grid item xs={3} className={classes.firstCell}>
//                                         <Typography>{cust.FullName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <Typography>{cust.sBusinessName}</Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <Typography style={{ cursor: "pointer" }} onClick={() => handleMobileClick(cust.sMobile)}>{cust.sMobile}</Typography>
//                                     </Grid>
//                                     <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
//                                         <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
//                                             {/* video */}
//                                             {
//                                                 cust.Video ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon} alt="Video" width={20} height={20} />
//                                                 ) : <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon2} alt="Video" width={20} height={20} style={{ filter: 'invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
//                                             }

//                                             {/* Audio */}
//                                             {
//                                                 cust.Audio ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon} alt="Audio" width={20} height={20} />
//                                                 ) : (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon2} alt="Audio" width={20} height={20} style={{ filter: 'invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
//                                                 )
//                                             }

//                                             {/* Text */}
//                                             {
//                                                 cust.Text ? (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon} alt="Text" width={20} height={20} />
//                                                 ) : (
//                                                     <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon2} alt="Text" width={20} height={20} style={{ filter: 'invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
//                                                 )
//                                             }
//                                         </div>
//                                     </Grid>
//                                 </Grid>
//                             )))
//                     )}
//                 </div>

//             </Paper>
//         </div>
//     )
// }

// export default memo(JPMCTestimonialMainGrid)


///////// Alignment and mobile on Hver changes .////////////
import React, { useCallback, useEffect, useState, memo } from 'react'
import { Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import audioIcon from "../../assets/audioIcon.svg"
import audioIcon2 from "../../assets/audioIcon2.svg"
import videoIcon from "../../assets/videoIcon.svg"
import videoIcon2 from "../../assets/videoIcon2.svg"
import textIcon from "../../assets/textIcon.svg"
import textIcon2 from "../../assets/textIcon2.svg"

// Custom styles
const useStyles = makeStyles(() => ({
    header: {
        backgroundColor: '#75287c',
        color: '#ffffff',
        fontWeight: 'bold',
    },
    row: {
        borderBottom: '1px solid #ccc',
    },
    cell: {
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    bordered: {
        borderLeft: '1px solid #ccc',
    },
    firstCell: {
        // padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', // <-- left align
        textAlign: 'left',            // <-- left align
    },
    leftAlignCell: {
        justifyContent: 'flex-start', // <-- left align
        textAlign: 'left',            // <-- left align
    },
    phoneNumber: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline !important', // <-- underline on hover
        },
    },
}));


function JPMCTestimonialMainGrid({ allUserTestimonials, searchedTestimonial, handleMobileClick, handleTestimonialIconClick }) {
    const classes = useStyles();
    return (
        <div className='testimonialGrid'>
            <Paper elevation={2} style={{ marginTop: '20px' }}>
                {/* Header Row (Fixed) */}
                <div style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#75287c' }}>
                    <Grid container className={`${classes.header} ${classes.row}`}>
                        <Grid item xs={3} className={classes.cell}>
                            <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Customer Name</Typography>
                        </Grid>
                        <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                            <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Business Name</Typography>
                        </Grid>
                        <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                            <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Phone Number</Typography>
                        </Grid>
                        <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                            <Typography style={{ color: '#fff', fontWeight: 'bold' }}>Testimonials</Typography>
                        </Grid>
                    </Grid>
                </div>

                {/* Scrollable Data Rows */}
                <div style={{ maxHeight: '700px', overflowY: 'auto' }}>
                    {allUserTestimonials.length === 0 ? (
                        <Grid container className={classes.row}>
                            <Grid item xs={12} className={classes.cell}>
                                <Typography>No data available</Typography>
                            </Grid>
                        </Grid>
                    ) : (
                        searchedTestimonial ? (
                            searchedTestimonial.map((cust, index) => (
                                <Grid container key={index} className={classes.row}>
                                    <Grid item xs={3}  className={`${classes.leftAlignCell} ${classes.cell}`}>
                                        <Typography>{cust.FullName}</Typography>
                                    </Grid>
                                    <Grid item xs={3}  className={`${classes.leftAlignCell} ${classes.cell} ${classes.bordered}`}>
                                        <Typography>{cust.sBusinessName}</Typography>
                                    </Grid>
                                    <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                                        <Typography className={classes.phoneNumber} onClick={() => handleMobileClick(cust.sMobile)}>
                                            {cust.sMobile}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                            {/* video */}
                                            {
                                                cust.Video ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon} alt="Video" width={20} height={20} />
                                                ) : <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon2} alt="Video" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                            }

                                            {/* Audio */}
                                            {
                                                cust.Audio ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon} alt="Audio" width={20} height={20} />
                                                ) : (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon2} alt="Audio" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                )
                                            }

                                            {/* Text */}
                                            {
                                                cust.Text ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon} alt="Text" width={20} height={20} />
                                                ) : (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon2} alt="Text" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(90%) contrast(85%)' }} />
                                                )
                                            }

                                        </div>
                                    </Grid>
                                </Grid>
                            ))
                        ) :
                            (allUserTestimonials.map((cust, index) => (
                                <Grid container key={index} className={classes.row}>
                                    <Grid item xs={3} className={`${classes.leftAlignCell} ${classes.cell}`}>
                                        <Typography>{cust.FullName}</Typography>
                                    </Grid>
                                    <Grid item xs={3} className={`${classes.leftAlignCell} ${classes.cell} ${classes.bordered}`}>
                                        <Typography>{cust.sBusinessName}</Typography>
                                    </Grid>
                                    <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                                        <Typography className={classes.phoneNumber} onClick={() => handleMobileClick(cust.sMobile)}>{cust.sMobile}</Typography>
                                    </Grid>
                                    <Grid item xs={3} className={`${classes.cell} ${classes.bordered}`}>
                                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                            {/* video */}
                                            {
                                                cust.Video ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon} alt="Video" width={20} height={20} />
                                                ) : <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="video" src={videoIcon2} alt="Video" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
                                            }

                                            {/* Audio */}
                                            {
                                                cust.Audio ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon} alt="Audio" width={20} height={20} />
                                                ) : (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="audio" src={audioIcon2} alt="Audio" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
                                                )
                                            }

                                            {/* Text */}
                                            {
                                                cust?.Text || cust?.TextDetail ? (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon} alt="Text" width={20} height={20} />
                                                ) : (
                                                    <img onClick={(e) => handleTestimonialIconClick(e, cust)} name="text" src={textIcon2} alt="Text" width={20} height={20} style={{ filter: 'invert(50%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(80%)' }} />
                                                )
                                            }
                                        </div>
                                    </Grid>
                                </Grid>
                            )))
                    )}
                </div>

            </Paper>
        </div>
    )
}

export default memo(JPMCTestimonialMainGrid)